import Repository from './Repository'

const resource = 'horses'

export default {
  getHorses (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  getHorse (tenantId, horseId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/${horseId}`, { params: params })
  },
  createHorse (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  createParentHorse (data) {
    return Repository.post(`horse-parents`, data)
  },
  getParentHorses (params) {
    return Repository.get(`horse-parents`, { params: params })
  },
  updateHorse (tenantId, horseId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${horseId}`, data)
  },
  getResultHorseExercise (tenantId, horseId, exerciseId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/${horseId}/exercise/${exerciseId}/results`, { params: params })
  }
}
